import React, { useEffect } from "react";

const GoogleMap = () => {
  useEffect(() => {
    const map = new window.google.maps.Map(document.getElementById("map"), {
      center: { lat: 23.0204978, lng: 72.4396548 },
      zoom: 15,
    });

    new window.google.maps.Marker({
      position: { lat: 23.0204978, lng: 72.4396548 },
      map: map,
      title: "Our Location",
    });
  }, []);

  return <div id="map" style={{ height: "400px", width: "100%" }}></div>;
};

export default GoogleMap;
